import { Route, Navigate } from 'react-router-dom';
import Login from '../Pages/Login';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { IPage, Page } from './Page';
import EventList from '../Pages/EventList';
import Settings from '../Pages/Settings';
import { ReactNode, useEffect} from 'react';
import { preloadAsync } from '../Services/SoundPlayer';
import Scanner from '../Pages/Scanner';
import GateSelector from '../Pages/GateSelector';
import TicketSearch from '../Pages/TicketSearch';
import TicketDetails from '../Pages/TicketDetails';
import ScanHistory from '../Pages/ScanHistory';
import EventMonitor from '../Pages/EventMonitor';
import Operation from './Operation';
import About from '../Pages/About';
import Counter from '../Pages/Counter';
import { isAndroid, isNativeDevice } from '../Platform';
import OfflineScans from '../Pages/OfflineScans';
import { useEventStatsProvider, EventStatsContext } from '../Hooks/EventStatsContext';
import "./App.scss"
import { AppBar } from './AppBar';


const theme = createTheme({
    palette: {
        background: {
            paper: '#fff',
        },
        text: {
            primary: '#173A5E',
            secondary: '#46505A',
        },
        action: {

        }
    },
});


const pages: IPage[] = [
    Login,
    EventList,
    Settings,
    Scanner,
    Counter,
    GateSelector,
    TicketSearch,
    TicketDetails,
    ScanHistory,
    About,
    EventMonitor,
    OfflineScans
];

function EventStats(props: { children: ReactNode }) {

    const eventStats = useEventStatsProvider();

    return <EventStatsContext.Provider value={eventStats}>
        {props.children}
    </EventStatsContext.Provider>
}

export default function App() {


    useEffect(() => {

        if (isAndroid() && !isNativeDevice() && process.env.NODE_ENV != 'development')
            window.location.href = "https://play.google.com/store/apps/details?id=it.art4art.codereader";
        preloadAsync();
    }, []);


    const routes = pages.map(a =>
        <Route key={a.name} path={a.route} element={<Page value={a} />} />
    );

    routes.push(
        <Route key="root" path="/" element={<Navigate replace to="/events" state={{ autoSelect : true }} />} />);

    return (
        <ThemeProvider theme={theme}>
            <Operation>
                <EventStats>
                    <div className="app">
                        <AppBar routes={routes} />
                    </div>
                </EventStats>
            </Operation>
        </ThemeProvider>
    );
}
